import React from "react";

const fmtUSD = (amount: number): string =>
  amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

interface EstimatedMonthlyCostProps {
  tierName: string;
  subscriptionPrice: number;
  includedTokensMillions: number;
  projectedOverageCost: number;
}

const EstimatedMonthlyCost: React.FC<EstimatedMonthlyCostProps> = ({
  tierName,
  subscriptionPrice,
  includedTokensMillions,
  projectedOverageCost,
}) => {
  const total = subscriptionPrice + projectedOverageCost;

  return (
    <div className="mt-4 rounded-lg border-2 border-indigo-200 bg-gradient-to-r from-indigo-50 to-purple-50 p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-indigo-900">
          Estimated Monthly Cost
        </p>
        <span className="text-xs text-indigo-600 bg-indigo-100 px-2 py-0.5 rounded-full font-medium">
          {tierName} Plan
        </span>
      </div>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Subscription ({tierName})</span>
          <span className="font-medium text-gray-900">
            {fmtUSD(subscriptionPrice)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Included tokens</span>
          <span className="font-medium text-gray-900">
            {includedTokensMillions}M
          </span>
        </div>
        {projectedOverageCost > 0 ? (
          <div className="flex justify-between">
            <span className="text-amber-700 font-medium">
              Projected refill overage
            </span>
            <span className="font-semibold text-amber-700">
              +{fmtUSD(projectedOverageCost)}
            </span>
          </div>
        ) : (
          <div className="flex justify-between">
            <span className="text-green-700">Projected refill overage</span>
            <span className="font-medium text-green-700">
              $0.00 (within included)
            </span>
          </div>
        )}
        <hr className="border-indigo-200" />
        <div className="flex justify-between items-baseline">
          <span className="font-bold text-indigo-900 text-base">
            Estimated total / month
          </span>
          <span className="font-bold text-indigo-900 text-xl">
            {fmtUSD(total)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EstimatedMonthlyCost;
